/**
 * @generated SignedSource<<a8f46f36cc9206ce74e761332053256d>>
 * @relayHash 1c1957f0674166c9db6b089b3b8bbf4a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 63b51752988a375e4ba7b59d39b515819298e285b93d0191029c8f91a60999c4

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateCascadingSelectFieldInput = {
  id: string;
  operation: JiraCascadingSelectFieldOperationInput;
};
export type JiraCascadingSelectFieldOperationInput = {
  childOption?: string | null | undefined;
  operation: JiraSingleValueFieldOperations;
  parentOption?: string | null | undefined;
};
export type cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation$variables = {
  input: JiraUpdateCascadingSelectFieldInput;
};
export type cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation$data = {
  readonly jira: {
    readonly updateCascadingSelectField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly " $fragmentSpreads": FragmentRefs<"cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation$rawResponse = {
  readonly jira: {
    readonly updateCascadingSelectField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly cascadingOption: {
          readonly childOptionValue: {
            readonly id: string;
            readonly isDisabled: boolean | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined;
          readonly parentOptionValue: {
            readonly id: string;
            readonly isDisabled: boolean | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly fieldId: string;
        readonly id: string;
        readonly name: string;
        readonly type: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation = {
  rawResponse: cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation$rawResponse;
  response: cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation$data;
  variables: cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": isSingleLineEventDelegatorEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isSingleLineEventDelegatorEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-event-delegator-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  {
    "kind": "ScalarField",
    "name": "value"
  },
  (v4/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraCascadingSelectFieldPayload",
            "kind": "LinkedField",
            "name": "updateCascadingSelectField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraCascadingSelectField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraCascadingSelectFieldPayload",
            "kind": "LinkedField",
            "name": "updateCascadingSelectField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraCascadingSelectField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "fieldId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "concreteType": "JiraCascadingOption",
                    "kind": "LinkedField",
                    "name": "cascadingOption",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": (v5/*: any*/)
                      },
                      {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": (v5/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "63b51752988a375e4ba7b59d39b515819298e285b93d0191029c8f91a60999c4",
    "metadata": {},
    "name": "cascadingSelect_issueFieldCascadingSelect_CascadingSelectFieldIsEditable_Mutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": isSingleLineEventDelegatorEnabled_provider
    }
  }
};
})();

(node as any).hash = "792c8e7af6ed535746e17a76dc52564b";

export default node;
